import React from "react";
import "./App.css";

function App() {
  return (
    <div className="App bg-slate-900 min-h-full">
      <div className="container mx-auto">xd</div>
    </div>
  );
}

export default App;
